import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import {
  newContratoDescentralizadoEditRoute,
  newContratoDescentralizadoRoute,
} from 'library/Routes';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  ContratoStatus,
  VersaoContratoEnum,
  STEP_DADOS_CONTRATADO,
  STEP_DOCUMENTOS,
  URL_ENTE_DESCENTRALIZADO,
  STEP_DADOS_COOPERATIVA,
} from '../../../../../models/contratos';
import {
  CreateRouteParams,
  EditRouteParams,
  ItemStepContrato,
} from '../__types';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  contratosNextStep,
  contratosPreviousStep,
  setCurrentContratoStep,
} from 'store/modules/AllContratos/AllContratosActions';
import {
  contratoAssessorDescentralizadoEdit,
  contratoAssessorDescentralizadoRegisterPreEtapa,
  loadContratoAssessor,
} from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import SnackbarUtils from 'utils/SnackbarUtils';
import { AxiosError } from 'axios';
import {
  loadAllEmpresas,
  loadEmpresaByCnpjComAcessoresNecessarios,
} from 'store/modules/EmpresasActions';
import { contratoEntePublicoDescentralizadoEdit, contratoEntePublicoDescentralizadoRegisterPreEtapa, loadContratoEntePublico } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { contratoEntePrivadoDescentralizadoEdit, contratoEntePrivadoDescentralizadoRegisterPreEtapa, loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';

const useContratoDescentralizadoStep = () => {

  const contratosAssessoresReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosAssessores.contratoEditing
  );

  const contratosEntePublicoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePublico.contratoEditing
  );

  const contratosEntePrivadoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePrivado.contratoEditing
  );

  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const currentStepContrato = useSelector(
    (state: RootState) => state.allContratos.currentContratoStep
  );
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const tipoContrato = params.tipoContrato;
  const etapa = params.etapa;
  const idContrato = params.id || null;
  const passo = params.passo;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);
  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);
  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);
  const stepDadosContrato = location.pathname.includes(CONTRATO_PASSOS.DADOS_CONTRATADO)
  const stepDadosCooperativa = location.pathname.includes(CONTRATO_PASSOS.DADOS_COOPERATIVA)

  const getItemContratoIndex = useCallback(
    (items: ItemStepContrato[]) => {
      return items.findIndex((item) => item.id === currentStepContrato);
    },
    [currentStepContrato]
  );

  useEffect(() => {
    const flgStatusEntePrivado = contratosEntePrivadoReducer.flgStatus;
    const flgStatusEntePublico = contratosEntePublicoReducer.flgStatus;
    const flgStatusAssessor = contratosAssessoresReducer.flgStatus;

    switch (true) {
      case fluxoAssessor:
        if (idContrato && flgStatusAssessor === ContratoStatus.EM_EDICAO && (stepDadosContrato || stepDadosCooperativa)) {
          dispatch(loadContratoAssessor(Number(idContrato), VersaoContratoEnum.CONTRATO));
        }
        break;
      case fluxoEntePublico:
        if (idContrato && flgStatusEntePublico === ContratoStatus.EM_EDICAO && (stepDadosContrato || stepDadosCooperativa)) {
          dispatch(loadContratoEntePublico(Number(idContrato), VersaoContratoEnum.CONTRATO));
        }
        break;
      case fluxoEntePrivado:
        if (idContrato && flgStatusEntePrivado === ContratoStatus.EM_EDICAO && (stepDadosContrato || stepDadosCooperativa)) {
          dispatch(loadContratoEntePrivado(Number(idContrato), VersaoContratoEnum.CONTRATO));
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [contratosEntePrivadoReducer.flgStatus, contratosEntePublicoReducer.flgStatus, fluxoEntePrivado, fluxoEntePublico, idContrato]);

  useEffect(() => {
    if (fluxoAssessor && (stepDadosContrato || stepDadosCooperativa)) {
      dispatch(loadAllEmpresas());
    }
    if (contratosAssessoresReducer.idEmpresa) {
      dispatch(
        loadEmpresaByCnpjComAcessoresNecessarios(
          contratosAssessoresReducer.cnpjEmpresa
        )
      );
    }
  }, [contratosAssessoresReducer.cnpjEmpresa,
  contratosAssessoresReducer.idEmpresa,
    dispatch,
    fluxoAssessor,
    stepDadosContrato,
    stepDadosCooperativa])

  useEffect(() => {
    let step = STEP_DADOS_COOPERATIVA;
    if (passo) {
      switch (passo) {
        case CONTRATO_PASSOS.DADOS_COOPERATIVA:
          break;
        case CONTRATO_PASSOS.DADOS_CONTRATADO:
          step = STEP_DADOS_CONTRATADO;
          break;
        case CONTRATO_PASSOS.DOCUMENTOS:
          step = STEP_DOCUMENTOS;
          break;
        default:
      }
      if (step !== currentStepContrato) {
        dispatch(setCurrentContratoStep(step));
      }
    }
  }, [passo, dispatch, currentStepContrato]);

  const navegaEntreSteps = useCallback(
    (step) => {
      let navegacaoPasso;
      switch (step) {
        case STEP_DADOS_COOPERATIVA:
          navegacaoPasso = CONTRATO_PASSOS.DADOS_COOPERATIVA;
          break;
        case STEP_DADOS_CONTRATADO:
          navegacaoPasso = CONTRATO_PASSOS.DADOS_CONTRATADO;
          break;
        case STEP_DOCUMENTOS:
          navegacaoPasso = CONTRATO_PASSOS.DOCUMENTOS;
          break;
        default:
          navegacaoPasso = CONTRATO_PASSOS.DADOS_COOPERATIVA;
          break;
      }
      if (navegacaoPasso) {
        const newPath = idContrato
          ? newContratoDescentralizadoEditRoute.getURLWithParams(
            tipoContrato,
            etapa,
            idContrato,
            navegacaoPasso
          )
          : newContratoDescentralizadoRoute.getURLWithParams(
            tipoContrato,
            navegacaoPasso
          );
        history.push(newPath);
      }
    },
    [history, tipoContrato, etapa, idContrato]
  );

  const assessorFluxo = async () => {
    const valoresAssessor = { ...contratosAssessoresReducer };
    if (idContrato) {
      if (
        valoresAssessor.flgStatus === ContratoStatus.VIGENTE ||
        valoresAssessor.flgStatus === ContratoStatus.ENCERRADO ||
        valoresAssessor.flgStatus === ContratoStatus.NAO_INICIADO ||
        valoresAssessor.ativo === false
      ) {
        navegaEntreSteps(STEP_DOCUMENTOS);
        return;
      } else if (valoresAssessor.flgStatus === ContratoStatus.EM_EDICAO) {
        await contratoAssessorDescentralizadoEdit(Number(idContrato), valoresAssessor, dispatch);
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.successContratoSalvar,
          options: { variant: 'success' },
        });
        navegaEntreSteps(STEP_DOCUMENTOS);
      }
    } else {
      const response = await contratoAssessorDescentralizadoRegisterPreEtapa(valoresAssessor, dispatch);
      const ID_CONTRATO_ASSESSOR = response.data.id;
      SnackbarUtils.enqueueSnackbar({
        message: languageValues.successContratoSalvar,
        options: { variant: 'success' },
      });
      history.push(
        newContratoDescentralizadoEditRoute.getURLWithParams(
          CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
          CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
          ID_CONTRATO_ASSESSOR,
          CONTRATO_PASSOS.DOCUMENTOS
        )
      );
    }
  };

  const entePublicoFluxo = async () => {
    const { codCoop, emailCoop, flgAnaliseJuridica, idEstado, nomCidade, programasEducacionais, totalMeses, dataInicio, dataFim } = contratosEntePublicoReducer;
    const valoresEntePublicoCreate = {
      codCoop,
      emailCoop,
      flgAnaliseJuridica,
      idEstado,
      nomCidade,
      programasEducacionais,
      totalMeses,
      dataInicio,
      dataFim
    };
    const valoresEntePublicoEdit = { ...contratosEntePublicoReducer }
    if (idContrato) {
      if (
        valoresEntePublicoEdit.flgStatus === ContratoStatus.VIGENTE ||
        valoresEntePublicoEdit.flgStatus === ContratoStatus.ENCERRADO ||
        valoresEntePublicoEdit.flgStatus === ContratoStatus.NAO_INICIADO ||
        valoresEntePublicoEdit.flgStatus === ContratoStatus.AGUARDANDO_EXTRATO ||
        valoresEntePublicoEdit.flgAtivo === false
      ) {
        navegaEntreSteps(STEP_DOCUMENTOS);
        return;
      } else if (valoresEntePublicoEdit.flgStatus === ContratoStatus.EM_EDICAO) {
        await contratoEntePublicoDescentralizadoEdit(Number(idContrato), valoresEntePublicoEdit, dispatch);
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.successContratoSalvar,
          options: { variant: 'success' },
        });
        navegaEntreSteps(STEP_DOCUMENTOS);
      }
    } else {
      const responseEntePublico = await contratoEntePublicoDescentralizadoRegisterPreEtapa(valoresEntePublicoCreate, dispatch);
      const ID_CONTRATO_ENTE_PUBLICO = responseEntePublico.data.id;
      SnackbarUtils.enqueueSnackbar({
        message: languageValues.successContratoSalvar,
        options: { variant: 'success' },
      });
      history.push(
        newContratoDescentralizadoEditRoute.getURLWithParams(
          CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
          CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
          ID_CONTRATO_ENTE_PUBLICO,
          CONTRATO_PASSOS.DOCUMENTOS
        )
      );
    }
  };

  const entePrivadoFluxo = async () => {
    const { codCoop, emailCoop, flgAnaliseJuridica, idEscola, nomEscola, cpfProfessor, programasEducacionais, totalMeses, dataInicio, dataFim } = contratosEntePrivadoReducer;
    const valoresEntePrivadoCreate = {
      codCoop,
      emailCoop,
      flgAnaliseJuridica,
      programasEducacionais,
      nomEscola,
      idEscola,
      cpfProfessor,
      totalMeses,
      dataInicio,
      dataFim
    };
    const valoresEntePrivadoEdit = { ...contratosEntePrivadoReducer }
    if (idContrato) {
      if (
        valoresEntePrivadoEdit.flgStatus === ContratoStatus.VIGENTE ||
        valoresEntePrivadoEdit.flgStatus === ContratoStatus.ENCERRADO ||
        valoresEntePrivadoEdit.flgStatus === ContratoStatus.NAO_INICIADO ||
        valoresEntePrivadoEdit.flgAtivo === false
      ) {
        navegaEntreSteps(STEP_DOCUMENTOS);
        return;
      } else if (valoresEntePrivadoEdit.flgStatus === ContratoStatus.EM_EDICAO) {
        await contratoEntePrivadoDescentralizadoEdit(Number(idContrato), valoresEntePrivadoEdit, dispatch);
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.successContratoSalvar,
          options: { variant: 'success' },
        });
        navegaEntreSteps(STEP_DOCUMENTOS);
      }
    } else {
      const responseEntePrivado = await contratoEntePrivadoDescentralizadoRegisterPreEtapa(valoresEntePrivadoCreate, dispatch);
      const ID_CONTRATO_ENTE_PRIVADO = responseEntePrivado.data.id;
      SnackbarUtils.enqueueSnackbar({
        message: languageValues.successContratoSalvar,
        options: { variant: 'success' },
      });
      history.push(
        newContratoDescentralizadoEditRoute.getURLWithParams(
          CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
          CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
          ID_CONTRATO_ENTE_PRIVADO,
          CONTRATO_PASSOS.DOCUMENTOS
        )
      );
    }
  };

  const avancaContratoStep = async () => {
    if (currentStepContrato === STEP_DADOS_CONTRATADO) {
      try {
        if (fluxoAssessor) {
          await assessorFluxo();
        } else if (fluxoEntePublico) {
          await entePublicoFluxo();
        } else if (fluxoEntePrivado) {
          await entePrivadoFluxo();
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        const errorMessage = axiosError?.response?.data?.message || languageValues.erroContratoPreCadastro;
        SnackbarUtils.enqueueSnackbar({
          message: errorMessage,
          options: { variant: 'error' },
        });
      }
    } else if (currentStepContrato < STEP_DOCUMENTOS) {
      dispatch(contratosNextStep());
      navegaEntreSteps(currentStepContrato + 1);
    }
  };

  const handleBackContratoStep = useCallback(() => {
    dispatch(contratosPreviousStep());
    navegaEntreSteps(currentStepContrato - 1);
  }, [currentStepContrato, dispatch, navegaEntreSteps]);

  return {
    avancaContratoStep,
    handleBackContratoStep,
    getItemContratoIndex,
    navegaEntreSteps,
    currentStepContrato,    
  };
};

export default useContratoDescentralizadoStep;
